import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectReceiptTransaction } from "../../../../redux/slices/receiptsSlice";
import ReceiptSummary from "../../ReceiptPage/ReceiptSummary/ReceiptSummary";

/**
 * @param {object} props
 * @param {object} props.control
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryDetails = ({ control }) => {
    const { recurring = {} } = useSelector(selectReceiptTransaction);
    const { status = "" } = recurring;

    const { options = {} } = control;
    const {
        accordionAdditionalText = "See next bill date and other gift details.",
        accordionLabel = "Your Summary",
    } = options;

    // Adding the event key to the list of activeEventKeys in the instance of
    // React context used in this instance of the accordion expands the
    // accordion so that element of the Accordion.Collapse is visible
    const yourDetailsEventKey = 0;
    // Setting the list of activeEventKeys to an empty array ensures that the
    // accordion is collapsed on page load
    const collapsedAccordionEventKeys = [];
    const [activeEventKeys, setActiveEventKeys] = useState(
        collapsedAccordionEventKeys,
    );

    const displayRecurringCallout = status !== "deleted";

    const recurringSummaryDetailsProps = {
        accordionAdditionalText,
        accordionLabel,
        displayPaymentDetails: true,
        displayPrintLink: false,
        displayTransactionId: false,
        displayRecurringCallout,
        printLinkLabel: "",
        activeEventKeys,
        control,
        setActiveEventKeys,
        yourDetailsEventKey,
    };

    return <ReceiptSummary {...recurringSummaryDetailsProps} />;
};

export default ConnectedRecurringSummaryDetails;
